import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'
import { TrackSale } from 'src/app/models/track-sale.model'
import { environment } from 'src/environments/environment'
import { NgModule } from '@angular/core'

@Component({
    selector: 'app-track-sale',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <mat-card>
      <mat-card-content>
      @if (!loading && !trackSales[0].title) {
        <div
          class="no-product"
          fxLayout
          fxLayoutAlign="center center"
          >
          リリース済みのトラックはありません。
        </div>
      }
      @if (loading || trackSales[0].title) {
        <div fxLayout>
          <div fxFlex="1 1 auto" fxLayout="column" fxLayoutGap="16px">
            <div fxLayout fxLayoutAlign="space-between" fxLayoutGap="16px">
              <app-data-field legend="曲名" fxFlex="1 1 30%">
                @for (trackSale of trackSales; track trackSale) {
                  <div>
                    <div
                      class="trend-item"
                      fxLayout="row wrap"
                      fxLayoutAlign="start baseline"
                      fxLayoutGap="8px"
                      >
                      @if (!loading) {
                        <div class="trend-item-title">
                          {{ trackSale.title }}
                        </div>
                      } @else {
                        <app-music-note></app-music-note>
                      }
                    </div>
                  </div>
                }
              </app-data-field>
              <app-data-field legend="売上（NET）" fxFlex="1 1 16%">
                @for (trackSale of trackSales; track trackSale) {
                  <div>
                    <div
                      class="trend-item"
                      fxLayout="row wrap"
                      fxLayoutAlign="start baseline"
                      fxLayoutGap="8px"
                      >
                      @if (!loading) {
                        <div class="trend-item-amount">
                          {{ trackSale.salesCurrencyAmount | number }}
                        </div>
                        <div fxLayout fxLayoutAlign="start center">
                          @if (trackSale.salesCurrencyAmountRate !== null) {
                            <div>{{ trackSale.salesCurrencyAmountRate | number: '1.0-0' }}%</div>
                            @if (trackSale.salesCurrencyAmountRate > 100) {
                              <mat-icon
                                >trending_up</mat-icon
                                >
                              }
                              @if (trackSale.salesCurrencyAmountRate < 100) {
                                <mat-icon
                                  >trending_down</mat-icon
                                  >
                                }
                              } @else {
                                <div>- %</div>
                              }
                            </div>
                          } @else {
                            <app-music-note></app-music-note>
                          }
                        </div>
                      </div>
                    }
                  </app-data-field>
                  <app-data-field legend="アルバム換算数" fxFlex="1 1 16%">
                    @for (trackSale of trackSales; track trackSale) {
                      <div>
                        <div
                          class="trend-item"
                          fxLayout="row wrap"
                          fxLayoutAlign="start baseline"
                          fxLayoutGap="8px"
                          >
                          @if (!loading) {
                            <div class="trend-item-amount">
                              {{ trackSale.trackAdjustedUnits | number }}
                            </div>
                            <div fxLayout fxLayoutAlign="start center">
                              @if (trackSale.trackAdjustedUnitsRate !== null) {
                                <div>{{ trackSale.trackAdjustedUnitsRate | number: '1.0-0' }}%</div>
                                @if (trackSale.trackAdjustedUnitsRate > 100) {
                                  <mat-icon
                                    >trending_up</mat-icon
                                    >
                                  }
                                  @if (trackSale.trackAdjustedUnitsRate < 100) {
                                    <mat-icon
                                      >trending_down</mat-icon
                                      >
                                    }
                                  } @else {
                                    <div>- %</div>
                                  }
                                </div>
                              } @else {
                                <app-music-note></app-music-note>
                              }
                            </div>
                          </div>
                        }
                      </app-data-field>
                      <app-data-field legend="トラックダウンロード数" fxFlex="1 1 16%">
                        @for (trackSale of trackSales; track trackSale) {
                          <div>
                            <div
                              class="trend-item"
                              fxLayout="row wrap"
                              fxLayoutAlign="start baseline"
                              fxLayoutGap="8px"
                              >
                              @if (!loading) {
                                <div class="trend-item-amount">
                                  {{ trackSale.trackDownloads | number }}
                                </div>
                                <div fxLayout fxLayoutAlign="start center">
                                  @if (trackSale.trackDownloadsRate !== null) {
                                    <div>{{ trackSale.trackDownloadsRate | number: '1.0-0' }}%</div>
                                    @if (trackSale.trackDownloadsRate > 100) {
                                      <mat-icon>trending_up</mat-icon>
                                    }
                                    @if (trackSale.trackDownloadsRate < 100) {
                                      <mat-icon
                                        >trending_down</mat-icon
                                        >
                                      }
                                    } @else {
                                      <div>- %</div>
                                    }
                                  </div>
                                } @else {
                                  <app-music-note></app-music-note>
                                }
                              </div>
                            </div>
                          }
                        </app-data-field>
                        <app-data-field legend="ストリーム数" fxFlex="1 1 16%">
                          @for (trackSale of trackSales; track trackSale) {
                            <div>
                              <div
                                class="trend-item"
                                fxLayout="row wrap"
                                fxLayoutAlign="start baseline"
                                fxLayoutGap="8px"
                                >
                                @if (!loading) {
                                  <div class="trend-item-amount">
                                    {{ trackSale.streams | number }}
                                  </div>
                                  <div fxLayout fxLayoutAlign="start center">
                                    @if (trackSale.streamsRate !== null) {
                                      <div>{{ trackSale.streamsRate | number: '1.0-0' }}%</div>
                                      @if (trackSale.streamsRate > 100) {
                                        <mat-icon>trending_up</mat-icon>
                                      }
                                      @if (trackSale.streamsRate < 100) {
                                        <mat-icon>trending_down</mat-icon>
                                      }
                                    } @else {
                                      <div>- %</div>
                                    }
                                  </div>
                                } @else {
                                  <app-music-note></app-music-note>
                                }
                              </div>
                            </div>
                          }
                        </app-data-field>
                      </div>
                    </div>
                  </div>
                }
                </mat-card-content>
              </mat-card>
    
    
    `,
    styleUrls: ['./track-sale.component.scss'],
    standalone: false
})
export class TrackSaleComponent implements OnInit {
  @Input()
  trackSales: TrackSale[] = []

  @Input()
  loading = true

  constructor() {}

  ngOnInit() {}
}
